/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    border: PropTypes.bool,
    number: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    border: false,
    componentClass: 'table',
    number: false,
};

const Table = (props) => {
    const classNames = [
        'c-table',
        props.border ? 'c-table_border' : '',
        props.number ? 'c-table_number' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Table.propTypes = propTypes;

Table.defaultProps = defaultProps;

export default Table;
